import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconLightBulb: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="light-bulb, idea, light"><path d="M8.75 21.25H15.25M14.75 15.5L9.25 15.4838M4.74823 9.00089C4.74823 4.99633 7.99456 1.75 11.9991 1.75C16.0037 1.75 19.25 4.99633 19.25 9.00089C19.25 11.3433 18.1392 13.4264 16.4157 14.7519C16.0528 15.031 15.6628 15.2765 15.2503 15.4838V18.25H8.74793V15.4838C8.33542 15.2765 7.94542 15.031 7.58257 14.7519C5.85901 13.4264 4.74823 11.3433 4.74823 9.00089Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconLightBulb;
